import {DataStatus} from 'platform/components';

import {useSelector} from 'react-redux';

import {Main} from '@dms/shared';
import {selectCarAudit} from '@dms/teas';

import {AdvertisementContent} from './components/AdvertisementContent';
import {AdvertisementPollingContext} from './components/AdvertisementPollingContext';

export const Advertisements = () => {
  const {loading} = useSelector(selectCarAudit);
  const isAuditLoading = loading['vehicleCatalogue/getCustomTenantCatalogue'];

  return (
    <Main>
      <DataStatus isLoading={isAuditLoading} minHeight={100}>
        <AdvertisementPollingContext>
          <AdvertisementContent />
        </AdvertisementPollingContext>
      </DataStatus>
    </Main>
  );
};
